import axios from 'axios';
import config from '../config/config';

const API_BASE = `${config.API_BASE}/empresa`;

export const listarEmpresas = () => axios.get(API_BASE);
export const cadastrarEmpresa = (dados) => axios.post(`${API_BASE}/cadastrar`, dados);
export const atualizarEmpresa = (id, dados) => axios.put(`${API_BASE}/${id}`, dados);
export const removerEmpresa = (id) => axios.delete(`${API_BASE}/${id}`);
export const atualizarParametros = (telefone, dados) =>
  axios.post(`${API_BASE}/atualizar-parametros/${telefone}`, dados);
